import { service } from "@/api/service ";
import { toastError } from "@/components/custom/Toast";

const state = {
  ecashPaymentResult: [],
  openDialog: false,
  paymentMethod: "",
};
const getters = {
  ecashResultGet: (state) => state.ecashPaymentResult,
  openDialogGet: (state) => state.openDialog,
  paymentMethodGet: (state) => state.paymentMethod,
};
const actions = {
  ecashPayment({ commit }, payLoad) {
    service.postFun(payLoad, `user/checkout`).then(
      (obj) => {
        console.log(obj, "result");
        commit("ecashPayment", obj.data);
        if (obj.data.method === "ecash") {
          window.location.replace(obj.data.url);
        } else {
          commit("openDialogMut", true);
          commit("paymentMethodMut", "ecash");
        }
      },
      (error) => {
        toastError(error);
      }
    );
  },
};
const mutations = {
  ecashPayment(state, result) {
    state.ecashPaymentResult = result;
  },
  openDialogMut(state, payload) {
    state.openDialog = payload;
  },
  paymentMethodMut(state, payload) {
    state.paymentMethod = payload;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
